import type { NamespaceSchema } from './types';

export const newsSettings: NamespaceSchema = {
  namespace: 'news-settings',
  label: 'News',
  description: 'Blog / news index settings. Drives /blog rendering.',
  sections: [
    {
      label: 'Listing',
      fields: [
        { kind: 'select', key: 'page_list_layout', label: 'Layout', default: 'grid', options: [
          { value: 'grid', label: 'Grid' },
          { value: 'list', label: 'List' },
          { value: 'magazine', label: 'Magazine (featured + grid)' },
        ] },
        { kind: 'number', key: 'posts_per_page', label: 'Posts per page', default: 12, min: 1, max: 60 },
        { kind: 'boolean', key: 'show_search_bar', label: 'Show search bar at top', default: true },
        { kind: 'boolean', key: 'show_categories_filter', label: 'Show category filter', default: true },
      ],
    },
    {
      label: 'Sidebar widgets',
      fields: [
        { kind: 'multiselect', key: 'sidebar_widgets', label: 'Widgets to show on detail page', default: ['recent', 'tags'], options: [
          { value: 'recent', label: 'Recent posts' },
          { value: 'popular', label: 'Most-viewed posts' },
          { value: 'categories', label: 'Categories' },
          { value: 'tags', label: 'Tags' },
          { value: 'newsletter', label: 'Newsletter signup' },
        ] },
      ],
    },
    {
      label: 'SEO',
      fields: [
        { kind: 'text', key: 'page_list_seo_title', label: 'Index meta title' },
        { kind: 'textarea', key: 'page_list_seo_desc', label: 'Index meta description', rows: 2 },
      ],
    },
  ],
};
